import React, { Component } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { StyleSheet, css } from 'aphrodite';

import Dialog from '@material-ui/core/Dialog';

import { DynamicForm } from './DynamicForm';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { CustomDynamicFormDialogStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { UiHelper } from '../helpers/UiHelper';
import { Fade, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class DynamicFormDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onCloseModal() {
    this.setState({
      screenMessage: ''
    });
    this.props.onClosed();
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    if (window.innerWidth && window.innerWidth < 1024) {
      return true
    }
    return false
  }

  render() {
    let dialogHeading = this.props.formDefinition.title
    const title = this.props.formDefinition.steps[0].fields.find(x => x.key === 'title')
    let deleteTitle = 'Delete'
    if(title && title.value) {
      deleteTitle = title.value
    }
    if (!dialogHeading) {
      if (this.props.formDefinition.formType === 'add') {
        dialogHeading = this.props.formDefinition.dialogHeading || 'Add'
      } else if (this.props.formDefinition.formType === 'edit') {
        dialogHeading = this.props.formDefinition.dialogHeading || 'Edit'
      } else if (this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') {
        dialogHeading = deleteTitle
      } else {
        dialogHeading = 'Add/Edit/Delete'
      }
    }

    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.formDefinition.steps[0].title}
        fullWidth={true}
        fullScreen={this.fullWidthCondition(fullWidthDialog)}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        classes={{
          root: css(Styles.customRoot),
          paper: css(Styles.customPaper),
        }}
        BackdropProps={fullWidthDialog && { style: { backgroundColor: 'unset' } }}

        maxWidth='md'
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          {/* <div className={css(Styles.modalTitle)}>{this.props.formDefinition.steps[0].title}</div> */}
          <div className={css(Styles.modalTitle)}>{dialogHeading}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {(this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') &&
            <p className={css(Styles.deleteMsg)}>{Helper.getString('deleteConfirmMsg')}</p>
          }
          {this.props.isOpen ? <DynamicForm {...this.props} /> : ''}
        </div>
      </Dialog>
    );
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('DynamicFormDialog')) ? CustomDynamicFormDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 25,
    paddingBottom: 10
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 33,
    right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },

  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  customPaper: {
    borderRadius: 40,
    // minWidth: 600,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      borderRadius: 0,
    },
  }
})



// WEBPACK FOOTER //
// ./src/common/components/DynamicFormDialog.js